export default function WhyHandle() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto mx-auto">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Comprendre le problème
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum mb-8 leading-tight">
            Poignée qui tourne dans le vide : <span className="font-serif italic">pourquoi</span>
          </h2>
          <div className="space-y-6 text-plum-dark leading-relaxed">
            <p className="text-base md:text-lg">
              Une poignée de fenêtre qui tourne dans le vide est un problème classique, et il y a toujours une raison technique. Le plus souvent, c'est la <strong>crémone</strong> — la barre verticale de fermeture qui actionne les points de serrage — qui est cassée ou desserrée. Quand la crémone ne transmet plus le mouvement de la poignée, la poignée tourne librement sans rien actionner. Une autre cause fréquente est le <strong>carré d'entraînement</strong> : la petite tige métallique qui relie la poignée à la crémone. Avec le temps, elle s'use, se déforme ou se casse, et le mouvement ne passe plus. Parfois, c'est simplement la poignée elle-même qui est fendue, en plastique devenu fragile, ou dont la vis de fixation est desserrée.
            </p>
            <p className="text-base md:text-lg">
              Chez DF PRO à Strasbourg, nous diagnostiquons la cause du problème sur place. Si c'est la poignée, nous la remplaçons. Si c'est la crémone ou le carré d'entraînement, nous remplaçons la pièce défectueuse. Toutes les pièces sont comprises dans le devis. Nous intervenons dans tout le Bas-Rhin, devis et déplacement gratuits, et nous avons les pièces des grandes marques en stock.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}